import {
  AMC_TAB_URL,
  MY_COUPON_TAB_URL,
  MY_DEVICES_TAB_URL,
  MY_ORDERS_TAB_URL,
  MY_SERVICES_TAB_URL,
  PROFILE_TAB_URL,
} from '@/configs/constants';

export const tabItemNames = {
  Profile: 'Profile',
  MyDevices: 'My Devices',
  MyOrders: 'My Orders',
  ServiceRequests: 'Service Requests',
  AMC: 'AMC',
  MyCoupon: 'My Coupon',
};

export const tabItems = [
  {
    name: tabItemNames.Profile,
    href: PROFILE_TAB_URL,
    icon: {
      blurDataURL: '/images/profileIcon.svg',
      height: 25,
      src: '/images/profileIcon.svg',
      width: 24,
    },
    activeIcon: {
      blurDataURL: '/images/profileIconActive.svg',
      height: 25,
      src: '/images/profileIconActiven.svg',
      width: 24,
    },
  },
  {
    name: tabItemNames.MyDevices,
    href: MY_DEVICES_TAB_URL,
    icon: {
      blurDataURL: '/images/myProductsIcon.svg',
      height: 24,
      src: '/images/myProductsIcon.svg',
      width: 24,
    },
    activeIcon: {
      blurDataURL: '/images/myProductsIconActive.svg',
      height: 24,
      src: '/images/myProductsIconActive.svg',
      width: 24,
    },
  },
  {
    name: tabItemNames.MyOrders,
    href: MY_ORDERS_TAB_URL,
    icon: {
      blurDataURL: '/images/myOrderIcon.svg',
      height: 24,
      src: '/images/myOrderIcon.svg',
      width: 24,
    },
    activeIcon: {
      blurDataURL: '/images/myOrderIconActive.svg',
      height: 24,
      src: '/images/myOrderIconActive.svg',
      width: 24,
    },
  },
  {
    name: tabItemNames.ServiceRequests,
    href: MY_SERVICES_TAB_URL,
    icon: {
      blurDataURL: '/images/myOrderIcon.svg',
      height: 24,
      src: '/images/myOrderIcon.svg',
      width: 24,
    },
    activeIcon: {
      blurDataURL: '/images/myOrderIconActive.svg',
      height: 24,
      src: '/images/myOrderIconActive.svg',
      width: 24,
    },
  },
  {
    name: tabItemNames.AMC,
    href: AMC_TAB_URL,
    icon: {
      blurDataURL: '/images/AMCIcon.svg',
      height: 24,
      src: '/images/AMCIcon.svg',
      width: 24,
    },
    activeIcon: {
      blurDataURL: '/images/AMCIconActive.svg',
      height: 24,
      src: '/images/AMCIconActive.svg',
      width: 24,
    },
  },
  {
    name: tabItemNames.MyCoupon,
    href: MY_COUPON_TAB_URL,
    icon: {
      blurDataURL: '/images/myCouponIcon.svg',
      height: 24,
      src: '/images/myCouponIcon.svg',
      width: 24,
    },
    activeIcon: {
      blurDataURL: '/images/myCouponIconActive.svg',
      height: 24,
      src: '/images/myCouponIconActive.svg',
      width: 24,
    },
  },
];
